export const FILTER_PANEL_LOCALE_ZHCHT = {
    filter: 'ç¯©é¸',
    confirm: 'ç¢ºå®',
    cancel: 'åæ¶',
    reset: 'æ¸ç©ºç¯©é¸',
    advancedFilter: 'æ´å¤ç¯©é¸',
    expand: 'å±é',
    fold: 'æ¶èµ·',
    last1Month: 'è¿ä¸æ',
    last3Month: 'è¿ä¸æ',
    last6Month: 'è¿åå¹´',
    pleaseInput: 'è«åéå¥',
    searchHistory: 'æ­·å²æç´¢',
    searchResult: 'æ¥è©¢çµæ',
    intervalFilter: 'æåéç¯©é¸',
    beginPlaceHolder: 'æä½å¼',
    endPlaceHolder: 'æé«å¼',
    dateBeginPlaceHolder: 'éå§æ¥æ',
    dateEndPlaceHolder: 'çµææ¥æ',
    empty: 'éç½®',
    clear: 'æ¸ç©ºç¯©é¸',
    today: 'ç¶å¤©',
    yesterday: 'æ¨å¤©',
    checkall: 'å¨é¸',
    searchPlaceHolder:'è«è¼¸å¥åç¨±',
    operators: {
        equal: 'ç­æ¼',
        notEqual: 'ä¸ç­æ¼',
        greater: 'å¤§æ¼',
        greaterOrEqual: 'å¤§æ¼ç­æ¼',
        less: 'å°æ¼',
        lessOrEqual: 'å°æ¼ç­æ¼',
        contains: 'åå«',
        notContains: 'ä¸åå«',
        like:  'åå«',
        notLike: 'ä¸åå«',
        in: 'å±¬æ¼',
        notIn: 'ä¸å±¬æ¼',
        empty: 'çºç©º',
        notEmpty: 'ä¸çºç©º',
        null: 'Null',
        notNull: 'ä¸çºNull'
    }
};
